import { render } from "./FatGradeNoTitleView.vue?vue&type=template&id=21309b12&scoped=true"
import script from "./FatGradeNoTitleView.vue?vue&type=script&lang=js"
export * from "./FatGradeNoTitleView.vue?vue&type=script&lang=js"

import "./FatGradeNoTitleView.vue?vue&type=style&index=0&id=21309b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21309b12"]])

export default __exports__